import type { MeterSearchResult } from '@/shared/meter-identification';

export { findBackendMeterMatches } from '@/features/scan/scan-backend-meter-results';

export function mergeMeterResults(results: MeterSearchResult[]) {
  const byKey = new Map<string, MeterSearchResult>();

  for (const result of results) {
    const key = readMeterResultKey(result);

    if (!byKey.has(key)) {
      byKey.set(key, result);
    }
  }

  return [...byKey.values()];
}

export function findOtherLocationResults(
  allResults: MeterSearchResult[],
  localResults: MeterSearchResult[],
  activeLocationId: number | string | undefined,
) {
  if (!activeLocationId) {
    return [];
  }

  const localKeys = new Set(localResults.map(readMeterResultKey));
  const normalizedActiveLocationId = String(activeLocationId);

  return mergeMeterResults(
    allResults.filter(
      result =>
        String(result.data.locationId) !== normalizedActiveLocationId && !localKeys.has(readMeterResultKey(result)),
    ),
  );
}

function readMeterResultKey(result: MeterSearchResult) {
  return result.data._id ? `inventory:${result.data._id}` : result.id;
}
